<ngx-avatar
  [src]="src"
  [name]="name"
  [borderColor]="borderColor"
  [size]="size"
  [cornerRadius]="cornerRadius"
  [round]="round"
  [value]="value"
  [bgColor]="bgColor"
></ngx-avatar>
